<script setup>
import { CheckIcon } from "@heroicons/vue/24/solid";
import { computed } from "vue";

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
  selectionIds: {
    type: Array,
    required: true,
  },
  setSelectionIds: {
    type: Function,
    required: true,
  },
  idKey: {
    type: String,
    required: false,
    default: null,
  },
  align: {
    type: String,
    default: "left",
    required: false,
  },
});

const isSelected = computed(() => {
  if (props.idKey) {
    return props.selectionIds.includes(props.row.original[props.idKey]);
  } else {
    return props.selectionIds.includes(props.row.original.id);
  }
});

function select() {
  let selectionIds = props.selectionIds;

  if (isSelected.value) {
    if (props.idKey) {
      selectionIds = selectionIds.filter(
        (id) => id !== props.row.original[props.idKey],
      );
    } else {
      selectionIds = selectionIds.filter((id) => id !== props.row.original.id);
    }
  } else {
    if (props.idKey) {
      selectionIds.push(props.row.original[props.idKey]);
    } else {
      selectionIds.push(props.row.original.id);
    }
  }

  props.setSelectionIds(selectionIds);
}
</script>

<template>
  <div
    class="flex h-full items-center p-4"
    :class="{
      'justify-start': props.align === 'left',
      'justify-center text-center': props.align === 'center',
      'justify-end': props.align === 'right',
    }"
  >
    <button
      type="button"
      class="group inline-flex size-[25px] items-center justify-center rounded border border-indigo-600 text-white duration-150 hover:bg-indigo-600"
      :class="{ 'bg-indigo-600 ': isSelected }"
      @click="select"
    >
      <CheckIcon
        class="size-4 text-white group-hover:visible"
        :class="[isSelected ? 'visible' : 'invisible']"
      />
    </button>
  </div>
</template>
